










import { Vue, Component } from 'vue-property-decorator';
import CertificadosBase from '@/pantallas/CertificadosBase/CertificadosBase.vue';

@Component({
  components: { CertificadosBase },
})
export default class CertificadosBasePantalla extends Vue {}
